(function () {
  document.querySelectorAll('.kvs-fsb[data-goal]').forEach(function (bar) {
    if (bar.dataset.fsbInitialized === 'true') return;
    bar.dataset.fsbInitialized = 'true';
    var msg = bar.querySelector('.kvs-fsb__message');
    var close = bar.querySelector('.kvs-fsb__close');
    var goal = Number(bar.getAttribute('data-goal'));
    var currency = bar.getAttribute('data-currency');
    var country = bar.getAttribute('data-country');
    var requestNumber = 0;

    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'cs', {
        style: 'currency', currency: 'CZK', minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(cents / 100);
    }

    function fallback() {
      msg.textContent = bar.getAttribute('data-msg-fallback');
    }

    function render(cart) {
      if (country !== 'CZ' || currency !== 'CZK' || cart.currency !== currency ||
          (!cart.requires_shipping && cart.item_count !== 0) || !Number.isFinite(goal) || goal <= 0 ||
          !Number.isFinite(cart.total_price) || cart.total_price < 0) {
        fallback();
        return;
      }
      var counted = cart.total_price;
      var remaining = Math.max(0, goal - counted);
      if (counted === 0) msg.innerHTML = bar.getAttribute('data-msg-goal').replace('__AMOUNT__', money(goal));
      else if (remaining > 0) msg.innerHTML = bar.getAttribute('data-msg-remaining').replace('__AMOUNT__', money(remaining));
      else msg.textContent = bar.getAttribute('data-msg-reached');
    }

    function refresh() {
      var currentRequest = ++requestNumber;
      return fetch(bar.getAttribute('data-cart-url'), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart unavailable');
          return response.json();
        })
        .then(function (cart) { if (currentRequest === requestNumber) render(cart); })
        .catch(function () { if (currentRequest === requestNumber) fallback(); });
    }

    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem('kvsFsbClosed', '1'); } catch (e) {}
        window.dispatchEvent(new Event('resize'));
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  });
})();
